import { Button } from "../Catalyst/button";
import clsx from "clsx";

// Loading spinner component
const LoadingSpinner = () => (
  <svg
    className="animate-spin h-4 w-4"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-slot="icon"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

// Map mode to Catalyst color
const getModeColor = (mode, bgColor) => {
  // If bgColor is explicitly provided, use it
  if (bgColor) {
    return bgColor;
  }
  
  switch (mode) {
    case "danger":
      return "red";
    case "default":
    default:
      return "dark";
  }
};

/**
 * Icon wrapper component that adds data-slot="icon" for Catalyst styling
 * Accepts either a React component (IconComponent) or a URL string (iconSrc)
 */
const ButtonIcon = ({ icon: IconComponent, iconSrc, iconAlt = "" }) => {
  if (IconComponent) {
    // React component icon (e.g., Heroicons)
    return <IconComponent data-slot="icon" />;
  }
  if (iconSrc) {
    // Image-based icon
    return (
      <img
        src={iconSrc}
        alt={iconAlt}
        className="h-4 w-4 sm:h-4 sm:w-4"
        data-slot="icon"
      />
    );
  }
  return null;
};

export const PellerexButton = ({
  className = '',
  disabled = false,
  type = "button",
  onClick = /** @type {any} */ (undefined),
  colour = undefined, // Deprecated - use color or mode instead
  color = /** @type {string | undefined} */ (undefined), // Catalyst color prop
  bgColor = undefined, // Background color: "indigo", "dark", "zinc", "red", etc. (defaults to "dark")
  mode = "default",
  loading = false,
  url = undefined,
  outline = false,
  plain = false,
  bold = false, // Whether to use bold font weight (defaults to false)
  href = undefined,
  icon = /** @type {any} */ (undefined), // React icon component (e.g., PlusIcon from Heroicons)
  iconSrc = undefined, // Image URL for icon
  iconAlt = "", // Alt text for image icon
  iconPosition = "left", // "left" or "right"
  children = /** @type {React.ReactNode} */ (undefined),
  ...props
}) => {
  const onClicked = (e) => {
    if (onClick) {
      onClick({ e, url });
    }
  };

  // Determine the color: explicit color prop > bgColor > mode mapping
  const buttonColor = color || getModeColor(mode, bgColor);

  const iconElement = (icon || iconSrc) ? (
    <ButtonIcon icon={icon} iconSrc={iconSrc} iconAlt={iconAlt} />
  ) : null;

  return (
    <Button
      type={type}
      disabled={disabled || loading}
      onClick={onClicked}
      color={outline || plain ? undefined : buttonColor}
      outline={outline}
      plain={plain}
      href={href}
      className={clsx(className, bold && "font-bold!")}
      {...props}
    >
      {iconPosition === "left" && iconElement}
      {children}
      {iconPosition === "right" && iconElement}
      {loading && <LoadingSpinner />}
    </Button>
  );
};
